import { useEffect, useState } from "react";
import ChrisLp3Waiting from "@/components/landing/chris/ChrisLp3Waiting";
import "@/styles/landing.css";

// DEV-ONLY (2026-09-27): Visuelle/geometrische Verifikation der Chris-LP3-
// Warteerfahrung OHNE echten, kostenpflichtigen KI-Lauf (Standard §26 / Auftrag §26).
// Nur registriert, wenn isDevPreviewEnabled() (localhost / *.preview.emergentagent.com).
//
// Query-Parameter:
//   q=<Begriff>     Suchbegriff (Default „Winkelschleifer")
//   ready=<ms>      simuliertes Backend-Ready nach n ms (Default 8000; 0=sofort; sehr gross=Late-Ready)
//   reduced=1       erzwingt den Reduced-Motion-Zweig deterministisch
export default function Lp3ChrisDevPreview() {
  const params = new URLSearchParams(window.location.search);
  const term = params.get("q") || "Winkelschleifer";
  const readyRaw = params.get("ready");
  const readyMs = readyRaw != null && readyRaw !== "" && !Number.isNaN(Number(readyRaw)) ? Number(readyRaw) : 8000;
  const reduced = params.get("reduced") === "1";
  const freezeState = params.get("state"); // DEV: Zustand deterministisch rendern (silence|introSpeech|progressA|progressB|waitBackend|finalSpeech)
  const freezeStage = params.get("stage") || "A";
  const freezeRevealed = Number(params.get("reveal") || 0);
  const debugBox = params.get("debug") === "1";

  const [ready, setReady] = useState(readyMs <= 0);
  const [handoff, setHandoff] = useState(false);

  useEffect(() => {
    if (readyMs <= 0) return undefined;
    const id = setTimeout(() => setReady(true), readyMs);
    return () => clearTimeout(id);
  }, [readyMs]);

  return (
    <div className="lp2-root" id="top" data-testid="lp3-chris-dev">
      <main>
        {handoff ? (
          <div style={{ minHeight: "82vh", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", padding: 40 }}>
            <div data-testid="lp3-chris-dev-handoff">
              <div style={{ fontFamily: "'Chivo'", fontWeight: 800, fontSize: 24, color: "#0f172a" }}>HANDOFF ausgelöst</div>
              <div style={{ marginTop: 10, color: "#64748b" }}>→ /unternehmer/welt/{"{id}"} (im echten Flow)</div>
            </div>
          </div>
        ) : (
          <ChrisLp3Waiting
            term={term}
            ready={ready}
            forceReduced={reduced}
            onHandoff={() => setHandoff(true)}
            freezeState={freezeState}
            freezeStage={freezeStage}
            freezeRevealed={freezeRevealed}
            debugBox={debugBox}
          />
        )}
      </main>
    </div>
  );
}
